/* eslint-disable security/detect-object-injection */
import React from 'react';
import { identificationLanguageContent } from '../../pages/IdentityDocument/IdentificationLanguageContent';
import { useContext } from 'react';
import ApplicationContext from '../../context/ApplicationContext';

function ChoiceSection({question, selectedChoice, setSelectedChoice, choice1, choice2, event, callback, handleNext, disabled}) {
    const { selectedLanguage } = useContext(ApplicationContext);
    const handleSelection = (choice) => {
        if(!disabled) {
            setSelectedChoice(choice);
            if(callback) {
                handleNext(choice);
            }
        }
    }
    return (
        <div>
            <p className='text-center text-sm font-normal'>{question}</p>
            <div className={`flex mt-[12px] justify-center ${disabled ? 'pointer-events-none' : ''}`}>
                <div onClick={() => handleSelection(choice1)} data-testid={`${event}_${choice1.replaceAll(' ', '_')}`}
                    className={`flex ${selectedChoice === choice1 ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-l-[47px] border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                    <p className={`font-normal ${selectedChoice === choice1 ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{identificationLanguageContent[(choice1).toLowerCase().replaceAll(' ', '-')][selectedLanguage]}</p>
                </div>
                <div onClick={() => handleSelection(choice2)} data-testid={`${event}_${choice2.replaceAll(' ','_')}`} className={`flex ${selectedChoice === choice2 ? 'bg-[#007EB4] text-[#F2F2F2]' : 'text-[#333333]'} justify-center gap-[12px] rounded-r-[47px] 
                            border border-[#333] items-center px-[30px] py-[8px] cursor-pointer`}>
                    <p className={`font-normal ${selectedChoice === choice2 ? ' text-[#F2F2F2]' : 'text-[#333333]'} text-sm`}>{identificationLanguageContent[(choice2).toLowerCase().replaceAll(' ', '-')][selectedLanguage]}</p>
                </div>
            </div>
        </div>
    );
}

export default ChoiceSection;